import { NamingConfig } from '@shared/naming/naming-config';

/**
 * `IrtOutgoingWorkflow` shape as returned by the hand-written
 * `irt-outgoing-workflows.gql.ts` documents (no generated `@schema` types exist
 * for these yet, so this is typed by hand, matching `IRT_OUTGOING_WORKFLOW_FIELDS`).
 */
export type IrtOutgoingWorkflow = {
  id: string;
  name: string;
  direction: string;
  /** `scheduled` or `realtime`. */
  mode: string;
  /** Base64-encoded graph JSON. Not needed by the list; present for completeness. */
  graph?: string | null;
  /**
   * Read-only, runtime-captured per-block output skeletons (JSON), plain text
   * like `graph` on read. Not sent back on save — the backend derives it from
   * runs, the editor only loads and (later) displays it.
   */
  pinsSchema?: string | null;
  /** Cron expression(s) — only meaningful when `mode === 'scheduled'`. */
  schedule?: string[] | string | null;
  /**
   * A plain number of interval minutes — the gateway's alternative to `schedule` for the same
   * trigger, never present alongside it (the service 400s a write carrying both). Only meaningful
   * when `mode === 'scheduled'`.
   */
  intervalMinutes?: number | null;
  isEnabled: boolean;
  createdUtc?: string;
  createdBy?: string;
  updatedUtc?: string;
  updatedBy?: string;
};

export const WorkflowNaming = NamingConfig<IrtOutgoingWorkflow>({
  key: 'Workflow',
  modelName: { '=1': $localize`Workflow`, other: $localize`Workflows` },
  fieldNames: {
    id: $localize`ID`,
    name: $localize`Name`,
    direction: $localize`Direction`,
    mode: $localize`Type`,
    graph: $localize`Graph`,
    pinsSchema: $localize`Pins schema`,
    schedule: $localize`Schedule`,
    intervalMinutes: $localize`Interval (minutes)`,
    isEnabled: $localize`Enabled`,
    createdUtc: $localize`Created`,
    createdBy: $localize`Created By`,
    updatedUtc: $localize`Last modified`,
    updatedBy: $localize`Last modified by`,
  },
});
